import React from 'react';
import { Button, Popover, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import TemplateEditorModal from '../modals/TemplateEditorModal'
import DeleteTemplateModal from '../modals/DeleteTemplateModal'
import ActiveVesrionConfirmModal from '../modals/ActivateVersionConfirmModal'
import $ from 'jquery';
import { connect } from 'react-redux'
import { withAlert } from 'react-alert';

import MoreVert from '../../images/sharp-more_vert-24px.svg'
import { Flag } from 'flagger/react'
import NewReportModal from '../modals/NewReportModal';

class EditorPopoverItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popoverOpen: false,
      modal: false,
      addmodal: false,
      editmodal: false,
      portfoliomodal: false,
      newVesrion: true,
      deleteModal: false,
      selectedDocument: {},
      selectedFileName: "",
      editMetaData: {},
      permissions: {},
      edit: true,
      displayTemplateEditorModal: false,
      displaynewReportModal: false,
      dislayRemoveTemplateModal: false,
      displayActivateNewVesrionModal: false,
      dislayCopyTemplateModal: false,
      associated: false
    };

    this.toggle = this.toggle.bind(this);
    this.showNewReportModal = this.showNewReportModal.bind(this)
    this.showTemplateEditorModal = this.showTemplateEditorModal.bind(this)
    this.removeTemplate = this.removeTemplate.bind(this)

    this.newVersionTemplate = this.newVersionTemplate.bind(this)
    this.editTemplate = this.editTemplate.bind(this)
    this.copyTemplate = this.copyTemplate.bind(this)
    this.showRemoveTemplateModal = this.showRemoveTemplateModal.bind(this)
    this.showActiveVersionConfirmModal = this.showActiveVersionConfirmModal.bind(this)
    this.makeTemplateActiveVersion = this.makeTemplateActiveVersion.bind(this)
    this.showCopyTemplateModal = this.showCopyTemplateModal.bind(this)

  }

  componentDidUpdate(prevProps, prevState) {

    if (prevState.displayTemplateEditorModal !== this.state.displayTemplateEditorModal && !this.state.displayTemplateEditorModal)
      this.props.refresh();

    if (prevState.displaynewReportModal != this.state.displaynewReportModal && !this.state.displaynewReportModal)
      this.props.refresh();

  }

  toggle() {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  }

  showNewReportModal() {
    this.setState({
      displaynewReportModal: !this.state.displaynewReportModal
    })
  }

  showTemplateEditorModal() {
    this.setState({
      displayTemplateEditorModal: !this.state.displayTemplateEditorModal
    })
  }

  showActiveVersionConfirmModal() {
    this.setState({
      displayActivateNewVesrionModal: !this.state.displayActivateNewVesrionModal,
      popoverOpen: false
    })
  }

  showRemoveTemplateModal() {
    this.setState({
      dislayRemoveTemplateModal: !this.state.dislayRemoveTemplateModal,
      popoverOpen: false
    })
  }

  showCopyTemplateModal() {
    this.setState({
      dislayCopyTemplateModal: !this.state.dislayCopyTemplateModal,
      popoverOpen: false
    })
  }

  editTemplate() {
    this.setState({
      edit: true,
      newVesrion: false
    });

    this.showTemplateEditorModal();
    this.toggle();
  }

  copyTemplate() {
    this.showCopyTemplateModal();
    this.toggle();
  }

  newVersionTemplate() {
    this.setState({
      edit: true,
      newVesrion: true
    });

    this.showTemplateEditorModal();
    this.toggle();
  }

  removeTemplate(id) {
    fetch(window.location.protocol + '//' + window.location.host + "/api/email/remove_email_template", {
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: id })
    })
      .then(res => res.json())
      .then(result => {
        //this.props.alert.success(result.message);
        this.showRemoveTemplateModal()
        this.props.refresh();
      })
  }

  makeTemplateActiveVersion(file) {
    fetch(window.location.protocol + '//' + window.location.host + "/api/email/make_template_active_version", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ _id: file._id, parentId: file.parentId })
    })
      .then(res => res.json())
      .then(result => {
        //this.props.alert.success(result.message);
        this.showActiveVersionConfirmModal()
        this.props.refresh();
      })
  }

  render() {
    const { localisation } = this.props.userReducer;

    let popoverItems = []

    let copyTemplateModal = {};
    let templateEditorModal = {};

    let templates = [];

    if (this.props.useFilteredTemplates) {
      if (this.props.file.templates) {
        templates = this.props.file.templates;
      }
    }

    //TODO: do we need this its in case of the system being set to use filters
    //but the data being in the old format.
    if (!this.props.file.templates) {
      templates.push(
        {
          Name: 'Template 1',
          html: this.props.file.html
        });

    }


    if (this.props.useFilteredTemplates) {
      if (this.state.dislayCopyTemplateModal)
        copyTemplateModal = <NewReportModal copy refresh={this.props.refresh} visible={this.state.dislayCopyTemplateModal} toggle={this.showCopyTemplateModal} file={this.props.file} useFilteredTemplates={true} />
      else
        copyTemplateModal = <div />

      if (this.state.displayTemplateEditorModal)
        templateEditorModal = <TemplateEditorModal edit={this.state.edit} newVersion={this.state.newVesrion} visible={this.state.displayTemplateEditorModal} toggle={this.showTemplateEditorModal} file={this.props.file} templates={templates} useFilteredTemplates={true} />
      else
        templateEditorModal = <div />
    }
    else {
      if (this.state.dislayCopyTemplateModal)
        copyTemplateModal = <NewReportModal copy refresh={this.props.refresh} visible={this.state.dislayCopyTemplateModal} toggle={this.showCopyTemplateModal} file={this.props.file} />
      else
        copyTemplateModal = <div />

      if (this.state.displayTemplateEditorModal)
        templateEditorModal = <TemplateEditorModal edit={this.state.edit} newVersion={this.state.newVesrion} visible={this.state.displayTemplateEditorModal} toggle={this.showTemplateEditorModal} file={this.props.file} />
      else
        templateEditorModal = <div />
    }

    let activeVersionConfirmModal = <ActiveVesrionConfirmModal visible={this.state.displayActivateNewVesrionModal} toggle={this.showActiveVersionConfirmModal} file={this.props.file} makeTemplateActiveVersion={this.makeTemplateActiveVersion} />
    let deleteConfirmationModal = <DeleteTemplateModal visible={this.state.dislayRemoveTemplateModal} toggle={this.showRemoveTemplateModal} file={this.props.file} removeTemplate={this.removeTemplate} name={this.props.filename} folder={this.props.file.folder} language={this.props.file.language} />

    popoverItems.push(<a class="s-list-default-btn-default s-popup-menu-no-icon" onClick={this.editTemplate} title="Edit"><div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-delete" />{localisation['popover_edit'] ? localisation['popover_edit'].element_lang : ''}</a>)

    if (this.props.editorpopoverchild)
      popoverItems.push(<a class="s-list-default-btn-default s-popup-menu-no-icon" onClick={this.showActiveVersionConfirmModal} title="Make Active Version"><div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-delete" />{localisation['popover_make_active'] ? localisation['popover_make_active'].element_lang : ''}</a>)

    popoverItems.push(<a class="s-list-default-btn-default s-popup-menu-no-icon" onClick={this.newVersionTemplate} title="NewVersion"><div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-delete" />{localisation['popover_new_version'] ? localisation['popover_new_version'].element_lang : ''}</a>)
    popoverItems.push(<a class="s-list-default-btn-default s-popup-menu-no-icon" onClick={this.copyTemplate} title="Copy"><div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-delete" />{localisation['popover_copy'] ? localisation['popover_copy'].element_lang : ''}</a>)
    popoverItems.push(<a class="s-list-default-btn-default s-popup-menu-no-icon" onClick={this.showRemoveTemplateModal} title="Delete"><div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-delete" />{localisation['popover_delete'] ? localisation['popover_delete'].element_lang : ''}</a>)

    return (
      <span>
        <Flag flag="v12" entity={{ id: 1 }} case="off">
          <Button className="s-record-picker s-fonticon-btn s-btn-menus" color="secondary" id={'Popover-' + this.props.id} style={{ alignContent: 'center' }} onClick={this.toggle}>
            
          </Button>
        </Flag>
        <Flag flag="v12" entity={{ id: 1 }} case="on">
          <Button className="s-record-picker s-fonticon-btn s-btn-menus" color="secondary" id={'Popover-' + this.props.id} onClick={this.toggle}>
            <img src={MoreVert} />
          </Button>
        </Flag>
        <Popover placement="top" hideArrow={true} isOpen={this.state.popoverOpen} target={'Popover-' + this.props.id} toggle={this.toggle}>
          {popoverItems}
        </Popover>
        {templateEditorModal}
        {deleteConfirmationModal}
        {activeVersionConfirmModal}
        {copyTemplateModal}
      </span>
    );
  }
}

export default connect(state => state)(EditorPopoverItem);